import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../../helper";

const storedUser = (() => {
  try {
    const raw = localStorage.getItem("authUser");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();

const initialState = {
  isAuthenticated: !!localStorage.getItem("authToken"),
  authToken: localStorage.getItem("authToken"),
  user: storedUser,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      const { token, user } = action.payload;
      state.isAuthenticated = true;
      const encryptedToken = CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
      state.authToken = encryptedToken;
      state.user = user || null;
      localStorage.setItem("authToken", encryptedToken);
      if (user) {
        localStorage.setItem("authUser", JSON.stringify(user));
      }
    },
    setUser: (state, action) => {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem("authUser", JSON.stringify(action.payload));
      } else {
        localStorage.removeItem("authUser");
      }
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.authToken = null;
      state.user = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
    },
  },
});

export const { login, setUser, logout } = authSlice.actions;

export default authSlice.reducer;
